import { createApi } from '@reduxjs/toolkit/query/react';
import WorkExperience from 'models/WorkExperience';
import { axiosBaseQuery } from 'services/api';

const WORK_EXPERIENCE_TAG = 'WorkExperience';

export const workExperienceApi = createApi({
  reducerPath: 'workExperienceApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/work_experiences/',
  }),
  tagTypes: [WORK_EXPERIENCE_TAG],
  endpoints: builder => ({
    getWorkExperience: builder.query({
      query: userId => ({
        url: `?user=${userId}`,
      }),
      transformResponse: response =>
        Array.isArray(response) ? response.map(exp => new WorkExperience(exp)) : [],
      providesTags: [WORK_EXPERIENCE_TAG],
    }),
    createWorkExperience: builder.mutation({
      query: workExperienceData => ({
        url: '',
        method: 'POST',
        data: workExperienceData,
      }),
      transformResponse: response => new WorkExperience(response),
      invalidatesTags: [WORK_EXPERIENCE_TAG],
    }),
    updateWorkExperience: builder.mutation({
      query: ({ id, ...workExperienceData }) => ({
        url: `${id}/`,
        method: 'PATCH',
        data: workExperienceData,
      }),
      transformResponse: response => new WorkExperience(response),
      invalidatesTags: [WORK_EXPERIENCE_TAG],
    }),
    deleteWorkExperience: builder.mutation({
      query: workExperienceId => ({
        url: `${workExperienceId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [WORK_EXPERIENCE_TAG],
    }),
  }),
});

export const {
  useGetWorkExperienceQuery,
  useCreateWorkExperienceMutation,
  useUpdateWorkExperienceMutation,
  useDeleteWorkExperienceMutation,
} = workExperienceApi;
